import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import moment from "moment";

@Injectable({
  providedIn: "root",
})
export class WorkdayReportService {
  public list: any = [];
  public singleReport: any;
  public mineReport: any;
  public categoriesList: { id: number; name: string }[] = [];

  constructor(public _httpClient: HttpClient) {}

  async getList(defRet: any = []): Promise<any> {
    return this._httpClient
      .get("/report")
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return defRet;
      });
  }

  async getExportList(month: any, year: any): Promise<any> {
    return this._httpClient
      .get("/report/data-for-export/" + month + "/" + year)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      });
  }

  async getMineReports(): Promise<any> {
    return this._httpClient
      .get("/me/report")
      .toPromise()
      .then((response) => {
        this.mineReport = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async get(id: number): Promise<any> {
    return this._httpClient
      .get("/report/" + id)
      .toPromise()
      .then((response) => {
        this.singleReport = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async getMineByDate(month: number = 0, year: number = 0) {
    month = month === 0 ? moment().month() + 1 : month;
    year = year === 0 ? moment().year() : year;

    return this._httpClient
      .get(`/me/report/${month}/${year}`)
      .toPromise()
      .catch((err: any) => {
        console.error(err);
        return {};
      });
  }

  async create(data: any = {}) {
    return this._httpClient
      .post("/report", data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      })
      .catch(async (err) => {
        return console.error(err);
      });
  }

  async update(id: number, data: any = {}) {
    return this._httpClient
      .put("/report/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  //Per archivio visualizzazione sendReport
  async sendReport(data: any = {}) {
    return this._httpClient
      .post("/report/send-and-save", data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async delete(id: number) {
    return this._httpClient
      .delete("/report/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        this.list = response;
        return response;
      });
  }

  async updateStatus(actions: string, data: any = []) {
    return this._httpClient
      .put("/report/update-status/" + actions, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async getCategoriesList() {
    return this._httpClient
      .get("/report-category")
      .toPromise()
      .then((response: { id: number; name: string }[]) => {
        this.categoriesList = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async deleteCategory(id: number) {
    return this._httpClient
      .delete("/report-category/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getCategoriesList();
        return response;
      });
  }

  async createCategory(data: { name: string }) {
    return this._httpClient
      .post("/report-category", data)
      .toPromise()
      .then(async (response) => {
        await this.getCategoriesList();
        return response;
      });
  }

  async updateCategory(id: number, data: { name: string }) {
    return this._httpClient
      .put("/report-category/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getCategoriesList();
      });
  }
}
